import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap, Mail, Phone, MapPin, ExternalLink } from 'lucide-react';

const Footer = () => {
}
export default Footer;
